import { render, staticRenderFns } from "./EditBlogs.vue?vue&type=template&id=41a78ebe&"
import script from "./EditBlogs.vue?vue&type=script&lang=js&"
export * from "./EditBlogs.vue?vue&type=script&lang=js&"
import style0 from "./EditBlogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports